// extracted by mini-css-extract-plugin
export default {"resizableHeader":"ResizableTable_resizableHeader__EyhdW","resizer":"ResizableTable_resizer__B2YkL","resizerIcon":"ResizableTable_resizerIcon__Hp2OY"};